<template>
  <div>
    <List>
      <input-focus inputType="text" v-model="name">
        {{ $l['bankName'] }}
      </input-focus>

      <input-focus inputType="text" v-model="branchName">
        {{ $l['branchName'] }}
      </input-focus>

      <div class="item" @click="selectAccountType()">
        {{ $l['accountType'] }}
        <span>{{ accountType }}</span>
      </div>

      <input-focus inputType="text" v-model="accountNumber">
        {{ $l['accountNumber'] }}
      </input-focus>
    </List>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import InputFocus from '@/components/InputFocus'
import _ from 'lodash'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List,
    InputFocus
  },

  computed: {
    name: {
      get: function () {
        return this.$store.state.bank.name
      },
      set: _.debounce(function (value) {
        this.setName(value)
        this.$store.dispatch('bank/saveName')
      }, 1000)
    },

    branchName: {
      get: function () {
        return this.$store.state.bank.branchName
      },
      set: _.debounce(function (value) {
        this.setBranchName(value)
        this.$store.dispatch('bank/saveBranchName')
      }, 1000)
    },

    accountType: function () {
      const accountType = this.$store.state.bank.accountType
      if (accountType) {
        return accountType.get(this.locale)
      }
      return ''
    },

    accountNumber: {
      get: function () {
        return this.$store.state.bank.accountNumber
      },
      set: _.debounce(function (value) {
        this.setAccountNumber(value)
        this.$store.dispatch('bank/saveAccountNumber')
      }, 1000)
    }
  },

  methods: {
    ...mapMutations('bank', [
      'setName',
      'setBranchName',
      'setAccountType',
      'setAccountNumber'
    ]),

    selectAccountType: function () {
      this.$store.dispatch('popup/show', 'accountType')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
